import React from "react";

import LoaderImg from "../../assets/Loader/Loading.gif";
import { useTranslation } from "react-i18next";

import "./index.scss";

const PageLoading = ({
  customHeight,
  backgroundColor,
  message,
  iconHeight,
  percentage,
}) => {
  const { t } = useTranslation();
  customHeight = customHeight || "calc(100vh - 48px)";
  backgroundColor = backgroundColor || "transparent";
  return (
    <div>
      <div
        className="loader-wrapper"
        style={{ height: customHeight, backgroundColor: backgroundColor }}
      >
        {" "}
        <img
          className={iconHeight ? iconHeight : "loaderImg"}
          src={LoaderImg}
          alt="loader-img"
        />
      </div>
      {percentage && (
        <div className="box-title message-position margin-top-10 marginBtm20">
          {" "}
          {t("ValueStrings.processing")} {percentage !== "0%" ? percentage : ""}
        </div>
      )}
      {message && <div className="box-title message-position">{message}</div>}
    </div>
  );
};

export const OverlayLoader = ({ customHeight }) => {
  return (
    <div className="loader-overlay">
      <PageLoading
        backgroundColor="var(--translucent-white)"
        customHeight={customHeight}
      />
    </div>
  );
};

export default PageLoading;
